module.exports = __webpack_public_path__ + "static/media/15.16f1864f.png";